import { useState } from "react";
import SidebarComp from "../../../components/Sidebar";
import Header from "../../../components/Header";
import "../styles/policydetails.css"
import Intimate_my_claims from "../../Intimate_my_claims";


const IntimateClaimsHome = () => {

    const [collapsed , setCollapsed] = useState(false)

    return (
      <>
        <div className="dashboard-main-cover-wrapper">
            <Header/>
            <div className="dashboard-inner-main-cover-wrapper">
              <div className="dashboard-sidebar">
                  <SidebarComp setCollapsed={setCollapsed} collapsed={collapsed}/>
              </div>
              <div className={ collapsed ? "dashboard-content-cover-closed-wrapper" : "dashboard-content-cover-wrapper"}>
                  <Intimate_my_claims/>
              </div>
            </div>
        </div>
      </>
    );
  };
  
  export default IntimateClaimsHome;